import { Cookie, getCookieConsent } from '../cookie.js';
import { cleanLinkID, documentNode, removeHTMLTags, getCleanURL, cfRight, UpdateQueryString, stripPii, cfIsNullOrWhitespace, parseUri } from '../utils/analytics-utils.js';
import { menuIdentifiers, cvPartnerExcludeDestination_LID, cvPartnerExcludeDomains,cvSourceExcludeDomains,
  cvDownloadExtentions, cvDriverDownloadDomains, cvDriverExtensions, cvNonDownloadExtensions, cvAMDWebProperties } from '../utils/string-constants.js';
import { convertCurrency } from '../utils/ppr-currency-converter.js'

// Last Update 02/19/2026 12:49 ET

function cfLnkClick(evt) {
  var isPromoClick = 0;
  var cvEvents = '', cvDFAEvent = '';
  let Destination_LID = '';
  let Destination_LPOS = '';
  let cvDestination_URL = '';
  let Destination_URL_wParam = '';
  let cvDestination_URL_ext = '';
  let Destination_Name = '';
  let Destination_Server = '';
  let Destination_Domain = '';
  let cvDownloadFileExt = '';
  let cvNRPPR = '';
  let Destination_ID = '';
  let Destination_URL_wParam_Original = '';
  let Destination_URL = '';
  const sAA = window.AMDAnalytics.sAA || {};
  sAA.linkType = '';
  sAA.eVar32 = '';
  sAA.eVar31 = '';
  sAA.eVar33 = '';
  sAA.eVarMan = '';
  sAA.eVarCat = '';
  sAA.Currency = '';
  let LnkTypePos = '';
  let o = evt.target;
  let cvLinkType = '';
  let cvTagName = '';
  let cvFoundChild;
  const isShadowRoot = (node) => node && node.nodeType === Node.DOCUMENT_FRAGMENT_NODE && node.host;
  if ("composed" in evt && typeof evt.composedPath === "function") {
    // Get the path of elements the event climbed through, e.g.
    // [span, div, div, section, body]
    const path = evt.composedPath();

    // Fetch reference to the element that was actually clicked
    const targetElement = path[0];

    // Check if any element in the composed path is within a shadow DOM
    const shadowHost = path.find((el) => el.shadowRoot);

    if (shadowHost) {
      // If the clicked element is within a shadow DOM, update the target
      o = targetElement;
    }
  }
  if (typeof o.tagName != 'undefined') {
    cvTagName = o.tagName.toLowerCase();
  }

  let cvURL = getCleanURL();

  var {cvPTagName, cvPPClassName, cvPPPClassName, cvPPPTagName} = documentNode(o);

  if ((cvTagName != 'a') && !((typeof o.parentNode != 'undefined') && (cvTagName == 'area' && cvPTagName == 'map')) && !(cvTagName == 'div' && decodeURIComponent(o.className) == 'accordiontitle') && (cvTagName != 'button')) {
    let exitLoop = 0;
    let treeLevels = 0;
    let GAo = o;
    let cvGATagName, cvGAPTagName, cvGAPPTagName, cvGAPPClassName, cvGAPPPTagName, cvGAPPPClassName, cvPPTagName;
    while (treeLevels < 4 && !exitLoop && GAo.tagName && GAo.tagName.toLowerCase() != "body") {
      if (GAo.parentNode && !isShadowRoot(GAo.parentNode)) {
        GAo = GAo.parentNode;
        if (typeof GAo.tagName != "undefined") {
          cvGATagName = GAo.tagName.toLowerCase();
        }

        if (GAo.parentNode && !isShadowRoot(GAo.parentNode)) {
          cvGAPTagName = GAo.parentNode.tagName.toLowerCase();

          if (
            GAo.parentNode.parentNode &&
            !isShadowRoot(GAo.parentNode.parentNode) &&
            !cfIsNullOrWhitespace(GAo.parentNode.parentNode) &&
            GAo.parentNode.tagName.toLowerCase() != "html" &&
            typeof GAo.parentNode.parentNode.tagName != "undefined"
          ) {
            cvGAPPTagName = GAo.parentNode.parentNode.tagName.toLowerCase();

            if (typeof GAo.parentNode.parentNode.className != "undefined") {
              const className = GAo.parentNode.parentNode.className;
              cvGAPPClassName = typeof className === "object" && typeof className.baseVal !== "undefined" ? className.baseVal.toLowerCase() : (className || "").toLowerCase();
            }

            if (
              GAo.parentNode.parentNode.parentNode &&
              !isShadowRoot(GAo.parentNode.parentNode.parentNode) &&
              !cfIsNullOrWhitespace(GAo.parentNode.parentNode.parentNode) &&
              GAo.parentNode.parentNode.tagName.toLowerCase() != "html" &&
              typeof GAo.parentNode.parentNode.parentNode.tagName != "undefined"
            ) {
              cvGAPPPTagName = GAo.parentNode.parentNode.parentNode.tagName.toLowerCase();

              if (typeof GAo.parentNode.parentNode.parentNode.className != "undefined") {
                const className = GAo.parentNode.parentNode.parentNode.className;
                cvGAPPPClassName = typeof className === "object" && typeof className.baseVal !== "undefined" ? className.baseVal.toLowerCase() : (className || "").toLowerCase();
              }
            } else {
              exitLoop = 1;
            }
          } else {
            exitLoop = 1;
          }
        } else {
          exitLoop = 1;
        }

        if (
          cvGATagName === "a" ||
          (GAo.parentNode && cvGATagName === "area" && cvGAPTagName === "map") ||
          (cvGATagName === "div" && decodeURIComponent(GAo.className) === "accordiontitle") ||
          cvGATagName === "button"
        ) {
          o = GAo;
          cvTagName = cvGATagName;
          cvPTagName = cvGAPTagName;
          cvPPTagName = cvGAPPTagName;
          cvPPPTagName = cvGAPPPTagName;
          cvPPClassName = cvGAPPClassName;
          cvPPPClassName = cvGAPPPClassName;
          exitLoop = 1;
        }
      } else {
        exitLoop = 1;
      }
      treeLevels++;
    }
  }
  if (cvTagName == 'a') {
    cvLinkType = 'Link|A';
    if (typeof (o.href) !== 'undefined') {
      Destination_URL_wParam = o.href.toLowerCase();
    }
    cvFoundChild = o.querySelector('img');
    if (cvFoundChild) {
      cvLinkType = 'Link|IMG';
      if (typeof (cvFoundChild.src) !== 'undefined') {
        let cvImageSRC = parseUri(cvFoundChild.src).host + parseUri(cvFoundChild.src).path;
        if (typeof cvFoundChild.alt !== "undefined" && cvFoundChild.alt !== "") {
          Destination_LID = `IMG|ALT|${cvImageSRC}|${decodeURIComponent(cvFoundChild.alt).trim()}`;
        } else if (typeof cvFoundChild.name !== "undefined" && cvFoundChild.name !== "") {
          Destination_LID = `IMG|NAME|${cvImageSRC}|${decodeURIComponent(cvFoundChild.name).trim()}`;
        } else if (typeof cvFoundChild.id !== "undefined" && cvFoundChild.id !== "") {
          Destination_LID = `IMG|ID|${cvImageSRC}|${decodeURIComponent(cvFoundChild.id).trim()}`;
        } else {
          Destination_LID = `IMG|SRC|${cvImageSRC}`;
        }
      }
      if (typeof o.name !== "undefined") {
        Destination_Name = decodeURIComponent(o.name);
      }
    }
    else if (typeof cvPPPTagName != 'undefined' && cvPPPTagName == 'div' && (cvPPPClassName && cvPPPClassName.includes('where_to_buy'))) {
      cvLinkType = 'Link|Shop'; // Shop WTB
    }
  }
  else if (typeof o.parentNode != 'undefined') {
    if (cvTagName == 'area' && cvPTagName == 'map') {
      cvLinkType = 'Link|IMGMAP';
    }
    else if ((cvTagName == "div" && decodeURIComponent(o.className) == "accordiontitle") || (cvTagName == "button" && decodeURIComponent(o.className).includes("cmp-accordion__button"))) {
      cvLinkType = "Link|AccordionTitle";
    } else if (cvTagName == "button") {
      cvLinkType = "Link|Button";
    }
  }
  if (!cfIsNullOrWhitespace(cvLinkType)) {
    if (cvLinkType == 'Link|A') {
      if (typeof o.className != 'undefined' && o.className === 'at-share-btn') {
        cvEvents += ',addthis';
      }
      if (typeof o.id != 'undefined' && o.id.indexOf('atic_') === 0) {
        cvEvents += ',addthis';
      }
      if (typeof o.href != 'undefined') {
        Destination_URL_wParam = decodeURIComponent(o.href.toLowerCase());
      }
      cvDestination_URL = Destination_URL_wParam.split('?')[0];
      Destination_LID = '';
      if (decodeURIComponent(o.textContent) != "") {
        if (Destination_LID == "") {
          // Figure out how to identify a hero button in AMD AEM.
          if (o.className == "hero_button" || (o.closest("div.heroExpressive") && o.closest("div.button"))) {
            Destination_LID = `Btn-hero|${decodeURIComponent(o.textContent).trim()}|${parseUri(cvDestination_URL).file || "N/A"}`;
            if (typeof o.name !== "undefined" && o.className == "hero_button") {
              Destination_LID += `|${o.name}`;
            }
          }
          // Figure out how to identify a tab in AMD AEM and track it (might need to just hook into dataLayer).
          else if (typeof o.parentNode != "undefined" && o.parentNode.tagName.toLowerCase() == "li" && /tab\d.*/i.test(o.parentNode.className)) {
            Destination_LID = `Tab|${o.parentNode.className.match(/tab\d.*/i)}|${decodeURIComponent(o.textContent).trim()}`;
          } else if (
            typeof o.parentNode != "undefined" &&
            typeof o.parentNode.parentNode != "undefined" &&
            o.parentNode.parentNode !== null &&
            typeof o.parentNode.parentNode.className != "undefined" &&
            (o.parentNode.parentNode.className.includes("addthis") || o.parentNode.parentNode.className.includes("at-share-btn"))
          ) {
            Destination_LID = `AddThis|${decodeURIComponent(o.textContent).trim()}`;
            Destination_LPOS = "AddThis";
            cvEvents += ",addthis";
          }
          // Fallback just get the button text.
          else {
            Destination_LID = decodeURIComponent(o.textContent).trim();
          }
        }
      } else if (decodeURIComponent(o.parentNode.className) != "") {
        // AR 3.2 to accomodate <DIV><A></A></DIV>
        Destination_LID = decodeURIComponent(o.parentNode.className).trim();
      } else if (decodeURIComponent(o.className) != "") {
        // AR 3.2 to accomodate <DIV><A></A></DIV>
        Destination_LID = decodeURIComponent(o.className).trim();
      } else {
        Destination_LID = Destination_URL_wParam;
      }
      Destination_Name = decodeURIComponent(o.name).trim();
      if (Destination_Name == 'undefined') {
        Destination_Name = '';
      }
      Destination_ID = decodeURIComponent(o.id); // AR 3.0 added "ID" attribute for LID and LPOS tracking
      if (!cfIsNullOrWhitespace(parseUri(Destination_URL_wParam).queryKey['promo'])) {
        Destination_LID = `${Destination_LID}|promo:${parseUri(Destination_URL_wParam).queryKey['promo']}`;
      }
    }
    else if (cvLinkType == 'Link|IMGMAP') {
      Destination_URL_wParam = decodeURIComponent(o.href.toLowerCase());
      cvDestination_URL = Destination_URL_wParam.split('?')[0];
      Destination_Name = decodeURIComponent(o.href);
      Destination_LID = `IMG|MAP|${Destination_Name}`;
    }
    else if (cvLinkType == 'Link|Shop') {
      Destination_URL_wParam = decodeURIComponent(o.href.toLowerCase());
      cvDestination_URL = Destination_URL_wParam.split('?')[0];
      Destination_Name = decodeURIComponent(o.href);
      Destination_LID = `Shop|WTB|${decodeURIComponent(o.innerHTML)}|${parseUri(Destination_URL_wParam).host}`;
      Destination_LPOS = 'Shop|WTB';
    }
    /*
    else if (cvLinkType == 'Link|Lightbox') {
      Destination_URL_wParam = decodeURIComponent(o.href.toLowerCase());
      cvDestination_URL = Destination_URL_wParam.split('?')[0];
      Destination_Name = decodeURIComponent(o.href);
      Destination_LID = `Lightbox|${decodeURIComponent(o.innerHTML).trim()}`;
      Destination_LPOS = 'Lightbox';
    }
    else if (cvLinkType == 'Link|CookieContent') {
      Destination_URL_wParam = decodeURIComponent(o.href.toLowerCase());
      cvDestination_URL = Destination_URL_wParam.split('?')[0];
      Destination_Name = decodeURIComponent(o.href);
      Destination_LID = `CookieContent|${decodeURIComponent(o.innerHTML).trim()}`;
      Destination_LPOS = 'CookieContent';
    }
    else if (cvLinkType == 'Link|MegaMenuSmall') {
      Destination_URL_wParam = decodeURIComponent(o.href.toLowerCase());
      cvDestination_URL = Destination_URL_wParam.split('?')[0];
      Destination_Name = decodeURIComponent(o.href);
      Destination_LID = `mm|${decodeURIComponent(o.innerHTML).trim()}`;
      Destination_LPOS = 'megamenu';
    }
    else if (cvLinkType == 'Link|HeaderNavlinks') {
      Destination_URL_wParam = decodeURIComponent(o.href.toLowerCase());
      cvDestination_URL = Destination_URL_wParam.split('?')[0];
      Destination_Name = decodeURIComponent(o.href);
      Destination_LID = `HeaderNavLinks|${decodeURIComponent(o.innerHTML).trim()}`;
      Destination_LPOS = 'HeaderNavLinks';
    }
    else if (cvLinkType == 'Link|LeftNavlinks') {
      Destination_URL_wParam = decodeURIComponent(o.href.toLowerCase());
      cvDestination_URL = Destination_URL_wParam.split('?')[0];
      Destination_Name = decodeURIComponent(o.href);
      Destination_LID = `LeftNavlinks|${decodeURIComponent(o.innerHTML).trim()}`;
      Destination_LPOS = 'LeftNavlinks';
    }
    else if (cvLinkType == 'Link|Breadcrumb') {
      Destination_URL_wParam = decodeURIComponent(o.href.toLowerCase());
      cvDestination_URL = Destination_URL_wParam.split('?')[0];
      Destination_Name = decodeURIComponent(o.href);
      Destination_LID = `Breadcrumb|${decodeURIComponent(o.innerHTML).trim()}`;
      Destination_LPOS = 'Breadcrumb';
    }
    */
    else if (cvLinkType == 'Link|IMG') {
      if (typeof o.href != 'undefined') {
        Destination_URL_wParam = decodeURIComponent(o.href.toLowerCase());
      }
      cvDestination_URL = Destination_URL_wParam.split('?')[0];
    }
    else if (cvLinkType == 'Link|AccordionTitle') {
      Destination_URL_wParam = 'AccordionTitle';
      Destination_LID = decodeURIComponent(removeHTMLTags(o.textContent.toLowerCase())).trim();
      Destination_Name = decodeURIComponent(removeHTMLTags(o.textContent.toLowerCase())).trim();
      Destination_LPOS = `AccordionTitle-${o.className.includes('cmp-accordion__button--expanded') ? 'close' : 'open'}`;
    }
    else if (cvLinkType == 'Link|Button') { // 4p server
      if (o.closest("div.heroExpressive") && o.closest("div.button")) {
        Destination_LID = `Btn-hero|${decodeURIComponent(o.innerHTML).trim()}|${parseUri((o.href ? o.href : cvURL) || '').file || 'N/A'}`;
        Destination_URL_wParam = (o.href || cvURL || '');
      }
      else {
        Destination_LID = Destination_Name = (o.id || '');
        Destination_URL_wParam = cvURL;
      }
    }

    Destination_URL_wParam = stripPii(Destination_URL_wParam);
    Destination_URL_wParam = UpdateQueryString('spUserID', 'pii', Destination_URL_wParam);

    Destination_Server = parseUri(Destination_URL_wParam).host;
    Destination_Domain = ',' + parseUri(Destination_URL_wParam).domain + '.' + parseUri(Destination_URL_wParam).tld;
    Destination_URL_wParam_Original = Destination_URL_wParam;
    Destination_URL_wParam = '/' + parseUri(Destination_URL_wParam).host + parseUri(Destination_URL_wParam).relative;
    Destination_URL = Destination_URL_wParam.split('?')[0];
    var cvIsThisADownload = 0;
    // AR 3.0 added "ID" attribute for LID and LPOS tracking
    if (!cfIsNullOrWhitespace(Destination_ID) && cfIsNullOrWhitespace(Destination_Name)) {
      Destination_Name = Destination_ID;
    }
    // AR 2.7: Destination_Name validation to track &lid and &lpos in URL parameters if no "name" attribute is defined
    if ((Destination_Name == 'undefined' || cfIsNullOrWhitespace(Destination_Name)) && cvAMDWebProperties.includes(Destination_Domain) && (Destination_URL_wParam.includes('lid=') || Destination_URL_wParam.includes('lpos='))) {
      Destination_Name = Destination_URL_wParam;
    }
    /*
    var DADapp = 0;
    if ((Destination_Name == 'undefined' || cfIsNullOrWhitespace(Destination_Name)) && cvURL.includes('appid=dad')) {
      DADapp = 1;
    }
    */
    if (Destination_Name) {
      Destination_Name = cleanLinkID(Destination_Name);
      const Destination_Name_Split = Destination_Name.split('&');
      for (var i = 0; i < Destination_Name_Split.length; i = i + 1) {
        if ((Destination_Name_Split[i].toLowerCase().indexOf('channelid=') == -1) && (Destination_Domain != ',en25.com') && (Destination_Server != 'link.global.amd.com')) {
          // AR 3.1 added filter to exclude LID tagging via URL for "channelid=" (salesedge portal issue)
          // added filter to exclude eloqua redirect domain containing lid
          if (Destination_Name_Split[i].toLowerCase().substr(0, 'lid='.length) === 'lid=') {
            Destination_LID = Destination_Name_Split[i].substring(4, Destination_Name_Split[i].length).replace('Pro Graphics a-n-d Accelerators', 'Pro Graphics & Accelerators'); // Extract LID (Link ID) from name="&lid="
            if (o.tagName == 'IMG' && o.parentNode.tagName == 'A') {
              Destination_LID = Destination_LID + ' | ' + cfRight(decodeURIComponent(o.src), 97 - Destination_LID.length);
            }
          }
          if (Destination_Name_Split[i].toLowerCase().substr(0, 'lpos='.length) === 'lpos=') {
            Destination_LPOS = Destination_Name_Split[i].substring(5, Destination_Name_Split[i].length); // Extract LPOS (Link Position) from name="&lpos="
          }
          if (Destination_Name_Split[i].toLowerCase().substr(0, 'lnktype='.length) === 'lnktype=') {
            LnkTypePos = Destination_Name_Split[i].substring(8, Destination_Name_Split[i].length);
            if (LnkTypePos.toLowerCase() == 'featured') {
              LnkTypePos = 'featuredlink';
            }
            else if (LnkTypePos.toLowerCase() == 'promo') {
              LnkTypePos = 'promolink';
            }
            else {
              LnkTypePos = '';
            }
          }
        } // close AR 3.1 if == -1
      }
      Destination_Name = Destination_Name.replace('Pro Graphics a-n-d Accelerators', 'Pro Graphics & Accelerators');
    }

    cvDownloadFileExt = parseUri(Destination_URL).file.split('.'); // AR 2.6: validate Null or Whitespace for URL
    cvDownloadFileExt = cvDownloadFileExt[cvDownloadFileExt.length - 1];
    if (!cfIsNullOrWhitespace(cvDownloadFileExt) && (!cvNonDownloadExtensions.includes(cvDownloadFileExt)) && (cvDownloadExtentions.includes(cvDownloadFileExt))) {
      // if extension on URL exists AND the extension is NOT in the exclude list AND the extension IS in the
      // download extension list, then set to 1
      // AR 2.5: removed !=0 condition to enable download tracking of exe files.
      // && cvDownloadExtentions.indexOf(cfUtility(Destination_URL,"ext")) != 0)
      // AR 2.6: false means extension exists; -1 means it exists as download file extension
      cvIsThisADownload = 1;
    }
    Destination_LID = removeHTMLTags(Destination_LID);

    /* Custom Link, Exit Link, Download Link */
    if (((cvAMDWebProperties.includes(Destination_Domain)) && (cvIsThisADownload != 1)) || (Destination_Domain.indexOf('undefined') != -1)) {
      sAA.linkType = 'o'; // Internal Links
    }
    else if ((cvAMDWebProperties.includes(Destination_Domain)) && (cvIsThisADownload == 1)) {
      sAA.linkType = 'd'; // Download Links
    }
    else if (cfIsNullOrWhitespace(Destination_URL_wParam_Original)) {
      sAA.linkType = 'o';
    }
    else {
      sAA.linkType = 'e'; // External Links
    }
    sAA.linkName = Destination_LID;
    sAA.linkURL = Destination_URL;
    // Non Revenue Partner Referral (NRPPR) BOF
    if (sAA.linkType == 'e') {
      // WTB CODE - PART 1
      if (o.hasAttribute('rel')) {
        let tempPPRScratch;
        let tempPPRScratch2;
        const tempPPR = cleanLinkID(o.getAttribute('rel'));
        if (tempPPR.includes('lpos=') && tempPPR.includes('&lid=')) {
          tempPPRScratch = tempPPR.split('lpos=')[1];
          tempPPRScratch2 = tempPPRScratch.split('&lid=');
          if (tempPPRScratch2[0] === "PPRlink") {
            Destination_LPOS = tempPPRScratch2[0];
            Destination_LID = tempPPRScratch2[1];
          }
        }
      }
      // END - WTB CODE - PART 1
      if (Destination_LPOS != 'PPRlink' && Destination_LPOS != 'RTPPRLink') {
        let Destination_CoreDomain = parseUri(Destination_URL_wParam_Original);
        if (Destination_URL_wParam_Original.indexOf('linksynergy') != -1) {
          const Destination_URL_wParam_Original_Split = Destination_URL_wParam_Original.split(/.*http/);
          Destination_CoreDomain = parseUri(decodeURIComponent(`http${Destination_URL_wParam_Original_Split[1]}`));
        }
        
        let SourceURL_CoreDomain = parseUri(cvURL);
        if ((!cvPartnerExcludeDomains.includes(Destination_CoreDomain.domain)) && ((!cvSourceExcludeDomains.includes(SourceURL_CoreDomain.host)) || (cvURL.includes('support.amd.com\/en-us\/download\/ccc')))) {
          cvNRPPR = '';
          if (/www.amd.com.*server.*series-processors.*/i.test(cvURL)) {
            cvNRPPR = 'NAServer|';
          }
          else if (cvURL.includes('products/processors/desktop/a-series-apu')) {
            Destination_LID = `Shop|WTB|APU|${Destination_LID}`;
            Destination_LPOS = 'Shop|WTB';
          }
          else if (cvURL.includes('promo')) {
            cvNRPPR = 'Promo';
          }
          else if (cvURL.includes('graphics/desktop')) {
            cvNRPPR = 'Graphics|Desktop';
          }
          else if (cvURL.includes('graphics/workstation')) {
            cvNRPPR = 'Graphics|Workstation';
          }
          else if (cvURL.includes('processors/desktop')) {
            cvNRPPR = 'Processors|Desktop';
          }
          else if (cvURL.includes('processors/notebook-tablet')) {
            cvNRPPR = 'Processors|Notebook-Tablet';
          }
          else if (cvURL.includes('processors')) {
            cvNRPPR = 'Processors';
          }
          else if (cvURL.includes('products/chipsets')) {
            cvNRPPR = 'Chipsets';
          }
          else if (cvURL.includes('products/embedded')) {
            cvNRPPR = 'Embedded';
          }
          else if (cvURL.includes('products/solid-state-drives')) {
            cvNRPPR = 'SSD';
          }
          else if (cvURL.includes('game')) {
            cvNRPPR = 'Game';
          }
          else if (cvURL.includes('solutions/software-partners')) {
            cvNRPPR = 'Solutions|Software';
          }
          else if (cvURL.includes('solutions/servers')) {
            cvNRPPR = 'Solutions|Server';
          }
          else if (cvURL.includes('server')) {
            cvNRPPR = 'Server';
          }
          else if (cvURL.includes('solutions/tablets')) {
            cvNRPPR = 'Solutions|Tablets';
          }
          else if (cvURL.includes('solutions/workstations')) {
            cvNRPPR = 'Solutions|Workstations';
          }
          else if (cvURL.includes('solutions/pro')) {
            cvNRPPR = 'Solutions|Pro';
          }
          else if (cvURL.includes('solutions/laptops')) {
            cvNRPPR = 'Solutions|Laptops';
          }
          else if (cvURL.includes('solutions/desktops')) {
            cvNRPPR = 'Solutions|Desktops';
          }
          else if (cvURL.includes('partners/distributor-locator')) {
            cvNRPPR = 'Partners|Distributor';
          }
          else if (cvURL.includes('partners/global-oems')) {
            cvNRPPR = 'Partners|Global OEM';
          }
          else if (cvURL.includes('partners/north-america-oems')) {
            cvNRPPR = 'Partners|NA OEM';
          }
          else if (cvURL.includes('partners/reseller-locator')) {
            cvNRPPR = 'Partners|Reseller';
          }
          else if (cvURL.includes('microsoft')) {
            cvNRPPR = 'Business|Microsoft';
          }
          else if (cvURL.includes('business')) {
            cvNRPPR = 'Business';
          }
          else if (cvURL.includes('consumer/where-to-buy')) {
            cvNRPPR = 'Consumer|WTB';
          }
          else if (cvURL.includes('press-releases')) {
            cvNRPPR = 'Press Release';
          }
          else if (cvURL.includes('who-we-are')) {
            cvNRPPR = 'Who We Are';
          }
          else if (/\/www\.amd\.com\/(\D\D-\D\D)\//i.test(cvURL)) {
            cvNRPPR = 'homepage:' + cvURL.match(/\D\D-\D\D/i);
          }
          else {
            cvNRPPR = 'ERROR';
          }
          if ((Destination_CoreDomain.domain != null) && cvNRPPR && (cvNRPPR != '')) {
            cvNRPPR = 'PartnerRef|' + Destination_CoreDomain.domain;
            if (cvPartnerExcludeDestination_LID.indexOf(Destination_LID) == -1) {
              cvNRPPR = 'PartnerRef|' + Destination_LID + '|' + Destination_CoreDomain.domain;
              sAA.eVar13 = sAA.prop13 = Destination_LID = cvNRPPR;
              if (cvNRPPR.indexOf('AppZone') != -1) {
                cvEvents += ',event80';
              }
              else if (cvNRPPR.indexOf('ERROR') == -1) {
                cvEvents += ',event99';
              }
            }
          }
        }
      }
    } // Non Revenue Partner Referral (NRPPR) EOF
    if (cvURL && cvURL != '') {
      sAA.prop12 = cvURL; // Clicks by Page URL
    }
    if (Destination_LID && Destination_LID != '') {
      sAA.eVar13 = sAA.prop13 = Destination_LID; // Clicks by Link ID
    }
    if (Destination_URL && Destination_URL != '') {
      sAA.prop14 = Destination_URL; // Clicks by Link URL - No Params
    }
    if (Destination_URL_wParam && Destination_URL_wParam != '') {
      sAA.eVar6 = Destination_URL_wParam; // Clicks by Link Full URL - With Params
    }
    if (Cookie.Enabled() && getCookieConsent().includes('C0002')) {
      Cookie.Set('c_rurl', cvURL, -15); // rurl = current URL as Referring URL; negative expiry value denotes seconds not days
    }
    if (Destination_LPOS && Destination_LPOS !== '') {
      Destination_LPOS = removeHTMLTags(Destination_LPOS);
    }
    if (o.hasAttribute('data-pulltag')) {
      const tmpOSSpos = o.getAttribute('data-pulltag');
      Destination_LPOS = ((Destination_LPOS) ? (`${Destination_LPOS}|${tmpOSSpos}`) : tmpOSSpos);
    }
    if (window.cfCheckRSID.ReportSuiteID.includes('amdvoss') && o.closest('div.view-content')) { // search result rank
      if (typeof o.dataset.searchRank != 'undefined') {
        Destination_LPOS = (o.dataset.searchRank + (Destination_LPOS ? '|' + Destination_LPOS : '')) || '(not set)';
      } else {
        Destination_LPOS = ('Unranked|' + (Destination_LPOS ? '|' + Destination_LPOS : '')) || '(not set)';
      }
      cvEvents += ',event13'; // Search Result Click
    }
    if (window.cfCheckRSID.ReportSuiteID.includes('amdvshop') && o.closest('div.view-content').length > 0 && typeof o.dataset.searchRank != 'undefined') {
      Destination_LPOS = o.dataset.searchRank + (Destination_LPOS ? `|${Destination_LPOS}` : '') || '(not set)';
    }
    if (Destination_LID && Destination_LID != '' && Destination_LID.indexOf('|Complete') != -1) {
      cvEvents += ',event98';
    }
    // Link Clicks Event
    if (typeof o.className !== 'undefined' && !/^chosen\-single/.test(o.className)) {
      cvEvents += ',event6';
    }

    /* Download Tracking */
    if (cvIsThisADownload) {
      let cvIsDownloadDomain = false;
      for (let n = 0; n < cvDriverDownloadDomains.length; n++) { // AR 2.8 checks if download file belongs to a download domain
        if (Destination_URL.indexOf(cvDriverDownloadDomains[n]) != -1) {
          cvIsDownloadDomain = true;
        }
      }
      if (!cvNonDownloadExtensions.includes(cvDownloadFileExt)) { // driver or asset only if extension is not on exlude list
        if (cvIsDownloadDomain && (Destination_URL_wParam.indexOf("driver") != -1 || Destination_URL_wParam.indexOf("amdgpu-install") != -1) && cvDriverExtensions.includes(cvDownloadFileExt)) {
          // AR 2.8 assign LID
          Destination_LID = "DD|";
          if (Destination_URL_wParam.indexOf("processor") != -1) {
            Destination_LID += "Processor";
          } else if (Destination_URL_wParam.indexOf("embedded") != -1) {
            Destination_LID += "Embedded";
          } else if (Destination_URL_wParam.indexOf("chipsetmotherboard") != -1) {
            Destination_LID += "Chipset";
          } else if (Destination_URL_wParam.indexOf("fire") != -1) {
            // firepro, firegl, firemv
            Destination_LID += "GPU-WS";
          } else {
            Destination_LID += "GPU-Other";
          }
          if (Destination_URL_wParam.indexOf("linux") != -1) {
            Destination_LID += "-Linux|";
          } else {
            Destination_LID += "|";
          }
          Destination_LID += parseUri(Destination_URL).file;
          sAA.linkName = Destination_LID;
          sAA.eVar13 = sAA.prop13 = Destination_LID;
          Destination_LPOS = "DD";
          cvEvents += ",event15";
          cvDFAEvent = "driver";
        } else {
          cvEvents += ",event4"; // Asset Downloads Event (event4)
          sAA.prop15 = sAA.eVar15 = Destination_LPOS = "AD";
          Destination_LID = `AD|${parseUri(Destination_URL).file}`;
          if ((sAA.prop14.includes("the_amd_story") || sAA.prop14.includes("the-amd-story")) && sAA.prop14.includes(".pdf")) {
            cvEvents += ",event32"; // AMD Story (event32)
          }
          cvDFAEvent = "asset";
        }
      }
    }
    // Custom Shop Now Link Tracking on Shop.amd.com SNC
    if (Destination_LPOS == 'PPRlink') {
      // How the heck do we track shop with the new data attributes?
      sAA.linkTrackVars += ',prop30,prop31,prop32,prop33,eVar20,eVar30,eVar31,eVar32,eVar33,eVar34,products';
      sAA.linkTrackEvents += ',event9,purchase';
      Destination_LID = Destination_LID.replace('|CND|', '|CAD|');
      const cvShop_LinkID = Destination_LID.split('|');
      sAA.prop30 = sAA.prop12;
      sAA.eVar30 = sAA.eVar8;

      // If the price data is in the link's dataset use the dataset instead of splitting strings.
      if (o.dataset.price) {
        const data = o.dataset;
        sAA.prop31 = sAA.eVar31 = data.retailer;
        sAA.Currency = convertCurrency(data.currency);
        sAA.prop32 = sAA.eVar32 = data.uniqueId;
        sAA.prop33 = sAA.eVar33 = data.price.replace(',', '.');
        sAA.eVar34 = `${data.linkType}|${data.shopProperty}|${data.retailer}|${data.uniqueId}`;
        sAA.eVarMan = data.manufacturer;
        sAA.eVarCat = data.category;
        sAA.eVarCat = sAA.evarCat ? sAA.eVarCat : 'N/A';
        sAA.eVarPrdNm = data.title;
        sAA.products = `;${data.uniqueId};1;${sAA.prop33}`;
      }
      else {
        sAA.prop31 = sAA.eVar31 = cvShop_LinkID[2]; // RetailerID
        // WTB Code Part 2 - Currency Conversion Code
        sAA.Currency = convertCurrency(cvShop_LinkID[2]);
        sAA.prop32 = sAA.eVar32 = cvShop_LinkID[3]; // ProductID
        sAA.prop33 = sAA.eVar33 = cvShop_LinkID[4].replace(',', '.'); // Price
        sAA.eVar34 = `${cvShop_LinkID[0]}|${cvShop_LinkID[1]}|${sAA.prop31}|${sAA.prop32}`;
        sAA.eVar13 = sAA.prop13 = `${sAA.eVar34}|${sAA.prop33}|${cvShop_LinkID[5]}`;
        if (cvShop_LinkID.length >= 8) {
          sAA.eVarMan = cvShop_LinkID[6];
          sAA.eVarCat = cvShop_LinkID[7];
          sAA.eVarCat = (sAA.eVarCat == 'null') ? 'N/A' : sAA.eVarCat;
        }
        if (cvShop_LinkID.length == 9) {
          sAA.eVarPrdNm = cvShop_LinkID[8];
        }
        sAA.products = `;${sAA.prop32};1;${cvShop_LinkID[4].replace(',', '.')}`;
      }

      const shopRealLnk = parseUri(Destination_URL_wParam.toLowerCase()).queryKey['rd_param1'] || parseUri(Destination_URL_wParam.toLowerCase()).queryKey['url'] || '';
      if (!cfIsNullOrWhitespace(shopRealLnk)) {
        let cvShopRealURL = '';
        try {
          cvShopRealURL = decodeURI(shopRealLnk);
        }
        catch (err) {
          cvShopRealURL = decodeURIComponent(shopRealLnk);
        }
        const cvShopURLTemp = `,${parseUri(cvShopRealURL).domain}.${parseUri(cvShopRealURL).tld}`;
        if (cvShopURLTemp.indexOf(',null.null') == -1) {
          Destination_Domain = cvShopURLTemp;
        }
      }
      cvEvents += ',event9';
      cvEvents += ',purchase';

      sAA.linkType = 's';
    }
  }
  if (cvTagName == 'button' && cfIsNullOrWhitespace(Destination_LID)) {
    let cloudsolutionsButtons = ['btn-learn', 'btn-action', 'download-btn', 'login-btn', 'btn-with-icon'];
    if (cvURL.includes('developer.amd.com')) {
      Destination_LID = o.hasAttribute('data-href') ? o.getAttribute('data-href') : '(not set)';
    }
    /** Drupal-specific Epyc CPU Selector. */
    else if (cvURL.toLowerCase().includes('amd.com/en/processors/epyc-cpu-selector') ||
      cvURL.toLowerCase().includes('amd.com/en/processors/epyc-virttcotool')) {
      const btnCheck = o.closest('a') ? o.closest('a').href : '';
      if (btnCheck.includes('/where-to-buy/epyc-processors') ||
        btnCheck.includes('/where-to-buy/epyc-platforms') ||
        btnCheck.includes('/where-to-buy/epyc-processors-sys-integrators')) {
        Destination_LID = o.textContent.trim() || "Generic Button";
        Destination_URL = btnCheck;
        Destination_URL_wParam = btnCheck;
        cvDestination_URL = btnCheck;
      }
    }
    else if (typeof o.className != 'undefined' && o.className === 'at-expanded-menu-button') {
      cvEvents += ',addthis';
    } else {
      const btnCheck2 = o.href || '';
      if (btnCheck2 !== '') {
        Destination_URL = btnCheck2;
        Destination_URL_wParam = btnCheck2;
        cvDestination_URL = btnCheck2;
      }
      Destination_LID = o.textContent.trim() || 'Generic Button';
    }
  }
  if (Destination_LPOS == 'RTPPRLink') {
    cvEvents = '';
  }
  if (!cfIsNullOrWhitespace(LnkTypePos)) {
    Destination_LPOS = !cfIsNullOrWhitespace(Destination_LPOS) ? `${Destination_LPOS}|${LnkTypePos}` : LnkTypePos;
  }

  const dataLposTemp = o.dataset ? o.dataset.lpos : "";
  let dataMenuPos;
  let tailLPOS;
  let tailLID;
  let menuText;
  let tailCheck;
  if (typeof o.className != "undefined" && o.className === "cmp-breadcrumb__item-link") {
    tailLID = Destination_LID ? `|${Destination_LID.trim()}` : '';
    menuText = o.getAttribute("data-tracking-information");
    let skip = '';
    if (!menuText) {
      const links = o.closest("div.breadcrumb").querySelectorAll("a");
      const linkNames = [];
      let lexit = false;
      links.forEach((element) => {
        if (!lexit) {
          linkNames.push(element.getAttribute("aria-label"));
          menuText = linkNames.join("|");
          lexit = o === element;
        }
      });
    }
    skip = menuText.split("|").pop();
    menuText = `Home-${menuText}`;
    tailCheck = `|${skip}` !== tailLID;
    Destination_LID = `menu-breadcrumb|${menuText}${tailCheck ? tailLID : ""}`;
    tailLPOS = ((typeof Destination_LPOS !== "undefined") && (Destination_LPOS !== "undefined") && (Destination_LPOS !== "")) ? `|${Destination_LPOS}` : "";
    Destination_LPOS = `menu-breadcrumb${tailLPOS}`;
  } else if (o.closest && typeof o.closest("div.header-logo")?.closest("header.common-header") !== "undefined" && o.closest("div.header-logo").closest("header.common-header")) {
    tailLID = Destination_LID ? `|${Destination_LID.trim()}` : "";
    tailCheck = `|home` !== tailLID;
    Destination_LID = `menu-home-logo|home${tailCheck ? tailLID : ""}`;
    tailLPOS = Destination_LPOS ? `|${Destination_LPOS}` : "";
    Destination_LPOS = `menu-home-logo${tailLPOS}`;
  } else if (o.closest && o.closest('[aria-labelledby="langDropdown"]') || (o.id || "").includes('langDropdown')) {
    tailLID = Destination_LID ? `|${Destination_LID.trim()}` : "";
    menuText = o.textContent.trim();
    menuText = menuText ? `language|${menuText}` : 'language'
    tailCheck = `|${menuText}` !== `|language${tailLID}`;
    Destination_LID = `menu-language|${menuText}${tailCheck ? tailLID : ""}`;
    tailLPOS = Destination_LPOS ? `|${Destination_LPOS}` : "";
    Destination_LPOS = `menu-language${tailLPOS}`;
  } else if (o.closest && o.closest('[aria-labelledby="signedInDropdown"]') || (o.id || "").includes('signedInDropdown') || o.closest && o.closest('[aria-labelledby="signedOutDropdown"]') || (o.id || "").includes('signedOutDropdown')) {
    menuText = o.getAttribute("data-tracking-information");
    const menuState = (o.closest('[aria-labelledby="signedInDropdown"]') || o.id.includes("signedInDropdown")) ? "signedInDropdown" : "signedOutDropdown";
    if (!menuText) {
      menuText = o.textContent.trim();
      menuText = menuText ? `${menuState}|${menuText}` : menuState;
    }
    tailLID = Destination_LID ? `|${Destination_LID.trim()}` : "";
    tailCheck = `|${menuText}` !== `|${menuState}${tailLID}`;
    Destination_LID = `menu-sign-in|${menuText}${tailCheck ? tailLID : ""}`;
    tailLPOS = Destination_LPOS ? `|${Destination_LPOS}` : "";
    Destination_LPOS = `menu-sign-in${tailLPOS}`;
  } else if (o.closest && typeof o.closest("ul.nav-mega")?.closest("header.common-header") !== "undefined" && o.closest("ul.nav-mega").closest("header.common-header")) {
    let linkwhatever = (o.getAttribute("data-tracking-information") || "").replace(/&amp;/gi, '&');
    let skip = '';
    if (linkwhatever) {
      skip = linkwhatever.split('|').pop();
    } else {
      const linkHierarchy = [];
      let tmpCheck;
      menuText = o.textContent.trim().replace(/&amp;/gi, "&");
      linkHierarchy.unshift(menuText);
      tmpCheck = o.closest(".cmp-text");
      if (tmpCheck) {
        linkHierarchy.unshift(tmpCheck.firstElementChild.textContent);
      } 
      tmpCheck = o.closest(".cmp-headermenu");
      tmpCheck = tmpCheck ? tmpCheck.querySelector(".cmp-headermenu__tab--active") : "";
      if (tmpCheck) {
        const tmpCheck1 = o.closest('div.cmp-headermenu__tablist');
        if (!tmpCheck1) {
          linkHierarchy.unshift(tmpCheck.textContent);
        }
      }
      tmpCheck = o.closest(".nav-item.dropdown");
      if (tmpCheck) {
        linkHierarchy.unshift(tmpCheck.firstElementChild.textContent);
      }
      linkHierarchy.forEach((e, i) => {
        linkHierarchy[i] = e.trim();
      });
      linkwhatever = [...new Set(linkHierarchy)].join("|").replace(/&amp;/gi, "&");
    }
    tailLID = Destination_LID ? `|${Destination_LID.trim().replace(/&amp;/gi, "&")}` : "";
    tailCheck = skip ? `|${skip}` !== tailLID : `|${menuText}` !== tailLID;
    Destination_LID = `menu-main|${linkwhatever}${tailCheck ? tailLID : ""}`;
    tailLPOS = Destination_LPOS ? `|${Destination_LPOS}` : "";
    Destination_LPOS = `menu-main${tailLPOS}`;
  } else if (
    (o.closest && typeof o.closest("ul.social-menu")?.closest("footer") !== "undefined" && o.closest("ul.social-menu").closest("footer")) ||
    o.closest && o.closest("section.bottom-menu") ||
    o.closest && o.closest("section#footer-main-link")
  ) {
    tailLID = Destination_LID ? `|${Destination_LID.trim()}` : "";
    menuText = o.getAttribute("data-tracking-information");
    let skip = "";
    if (menuText) {
      skip = menuText.split("|").pop();
    } else {
      menuText = o.textContent.trim();
    }
    tailCheck = skip ? `|${skip}` !== tailLID : `|${menuText}` !== tailLID;
    let footerheading;
    if (typeof o.closest("ul.social-menu")?.closest("footer") !== "undefined" && o.closest("ul.social-menu").closest("footer")) {
      dataMenuPos = "menu-social-menu";
    } else if (o.closest("section.bottom-menu")) {
      dataMenuPos = "menu-footer-secondary";
    } else if (o.closest("section#footer-main-link")) {
      dataMenuPos = 'menu-footer';
      footerheading = skip ? "" : `|${o.closest("div.cmp-container")?.firstElementChild?.querySelector("a.cmp-title__link")?.textContent}`;
      if (typeof footerheading === 'undefined' || footerheading === '|undefined') {
        footerheading = '';
      }
    } else {
      dataMenuPos = "(not set)";
    }
    Destination_LID = `${dataMenuPos}${footerheading ? footerheading : ""}|${menuText}${tailCheck ? tailLID : ""}`;
    tailLPOS = Destination_LPOS ? `|${Destination_LPOS}` : "";
    Destination_LPOS = dataMenuPos + tailLPOS;
  } else if (menuIdentifiers.includes(dataLposTemp)) {
    let dropDownParent;
    let dropDownSubParent;

    if (dataLposTemp === "menu-promo") {
      dropDownParent = o.closest(".dropdown").querySelector(".dropdown-toggle").textContent.trim();
      dropDownSubParent = o.closest("li").querySelector("a").textContent.trim();
    } else {
      dropDownParent = o.closest(".dropdown")?.querySelector(".dropdown-toggle")?.textContent.trim();
      dropDownSubParent = o.closest("li.dropdown-submenu")?.querySelector("a")?.textContent.trim();
    }
    tailLID = Destination_LID ? `|${Destination_LID}` : "";
    menuText = decodeURIComponent(o.innerHTML).trim();
    if (typeof dropDownParent !== "undefined" && dropDownParent !== "") {
      if (typeof dropDownSubParent !== "undefined" && dropDownSubParent !== "") {
        dropDownParent = `${dropDownParent}|${dropDownSubParent}`;
      }
      tailCheck = `|${menuText}` !== tailLID;
      Destination_LID = `${dataLposTemp}|${decodeURIComponent(dropDownParent)}|${menuText}${tailCheck ? tailLID : ""}`;
    } else if (dataLposTemp === "language-menu") {
      Destination_LID = `${dataLposTemp}|${o.closest(".links").previousElementSibling.textContent.trim()}|${menuText}`;
    } else {
      tailCheck = `|${menuText}` !== tailLID;
      Destination_LID = `${dataLposTemp}|${menuText}${tailCheck ? tailLID : ""}`;
    }
    tailLPOS = Destination_LPOS ? `|${Destination_LPOS}` : "";
    Destination_LPOS = dataLposTemp + tailLPOS;
  } else if (/^hotspots\-/i.test(dataLposTemp)) {
    tailLPOS = Destination_LPOS ? `|${Destination_LPOS}` : "";
    Destination_LPOS = dataLposTemp + tailLPOS;
  }

  // Update Destination_LPOS if link is in a carousel
  if (o.dataset?.carousel?.length !== 0) {
    const tmpcar2 = o.dataset ? (o.dataset.carousel || '') : '';
    if (tmpcar2) {
      Destination_LPOS = Destination_LPOS ? `${Destination_LPOS}|${tmpcar2}` : tmpcar2;
    }
  }

  if (((parseUri(cvURL).host == 'www.amd.com' || parseUri(cvURL).host == 'amd.com') && (/\/(en|de|es|fr|ja|ko|pl|pt|ru|tr|zh\-(hans|cn))\/partner($|\/$|\#|\?|\/#|\/\?)/i.test(cvURL))) && o.hasAttribute('lpos')) {
    const tmppos = o.getAttribute('lpos');
    Destination_LPOS = ((Destination_LPOS) ? (`${Destination_LPOS}|${tmppos}`) : tmppos);
  }

  cvDestination_URL = stripPii(cvDestination_URL);

  if (typeof sAA.eVarCat !== 'undefined') {
    const prodCategoryTemp = sAA.eVarCat.trim();
    if (/^graphics?\scards?$/i.test(prodCategoryTemp)) {
      sAA.eVarCat = 'Graphics Cards';
      Destination_LID = Destination_LID.replace(/\|graphics?\scards?\|/i, '|Graphics Cards|');
    }
    else if (/^desktops?$/i.test(prodCategoryTemp)) {
      sAA.eVarCat = 'Desktops';
      Destination_LID = Destination_LID.replace(/\|desktops?\|/i, '|Desktops|');
    }
    else if (/^processors?$/i.test(prodCategoryTemp)) {
      sAA.eVarCat = 'Desktop Processors';
      Destination_LID = Destination_LID.replace(/\|processors?\|/i, '|Desktop Processors|');
    }
    else if (/^desktop\sprocessors?$/i.test(prodCategoryTemp)) {
      sAA.eVarCat = 'Desktop Processors';
      Destination_LID = Destination_LID.replace(/\|desktop\sprocessors?\|/i, '|Desktop Processors|');
    }
    else if (/^server\sprocessors?$/i.test(prodCategoryTemp)) {
      sAA.eVarCat = 'Server Processors';
      Destination_LID = Destination_LID.replace(/\|server\sprocessors?\|/i, '|Server Processors|');
    }
    else if (/^notebooks?$/i.test(prodCategoryTemp)) {
      sAA.eVarCat = 'Laptops';
      Destination_LID = Destination_LID.replace(/\|notebooks?\|/i, '|Laptops|');
    }
    else if (/^laptops?$/i.test(prodCategoryTemp)) {
      sAA.eVarCat = 'Laptops';
      Destination_LID = Destination_LID.replace(/\|laptops?\|/i, '|Laptops|');
    }
    else if (/^motherboards?$/i.test(prodCategoryTemp)) {
      sAA.eVarCat = 'Motherboards';
      Destination_LID = Destination_LID.replace(/\|motherboards?\|/i, '|Motherboards|');
    }
    else if (/^workstations?$/i.test(prodCategoryTemp)) {
      sAA.eVarCat = 'Workstations';
      Destination_LID = Destination_LID.replace(/\|workstations?\|/i, '|Workstations|');
    }
    else if (/^servers?$/i.test(prodCategoryTemp)) {
      sAA.eVarCat = 'Server Processors';
      Destination_LID = Destination_LID.replace(/\|servers?\|/i, '|Server Processors|');
    }
    else if (/^amd\sfan\sstore$/i.test(prodCategoryTemp)) {
      sAA.eVarCat = 'AMD Fan Store';
      Destination_LID = Destination_LID.replace(/\|amd\sfan\sstore\|/i, '|AMD Fan Store|');
    }
    else if (/^various$/i.test(prodCategoryTemp)) {
      sAA.eVarCat = 'Various';
      Destination_LID = Destination_LID.replace(/\|various\|/i, '|Various|');
    }
  }

  window.cvLnkTrack = {
    DestLID: Destination_LID || '(not set)',
    DestLPOS: Destination_LPOS || '(not set)',
    DestURL: cvDestination_URL || '(not set)',
    Events: cvEvents || '(not set)',
    DestURLwParam: Destination_URL_wParam || '(not set)',
    DestURLext: cvDestination_URL_ext || '(not set)',
    DestName: Destination_Name || '(not set)',
    DestServer: Destination_Server || '(not set)', // with subdomain
    DestDomain: Destination_Domain || '(not set)', // without subdomain
    DownloadFileExt: cvDownloadFileExt || '(not set)',
    PartnerReferral: cvNRPPR || '(not set)',
    LinkType: sAA.linkType || '(not set)',
    DFAEvent: cvDFAEvent || '(not set)',
    ProductID: sAA.eVar32 || '(not set)',
    RetailerID: sAA.eVar31 || '(not set)',
    Price: sAA.eVar33 || '0.01',
    Manufacturer: sAA.eVarMan || '(not set)',
    Category: sAA.eVarCat || '(not set)',
    ProductName: sAA.eVarPrdNm || '(not set)',
    DestLPOSCD19: Destination_LPOS || 'Other',
    Currency: sAA.Currency || window.cfCheckRSID.cvCurrency
  };
  const { cvLnkTrack } = window;
  if (isPromoClick || o.hasAttribute && o.hasAttribute('intpromo')) {
    const that = o;
    const IPCountText = that.getAttribute('intpromo');
    if (typeof IPCountText !== 'undefined') {
      var IPCount = parseInt(IPCountText.substring(2), 10);
      let cvPromoImageSRC = '';
      let cvPromoFoundChild;
      let cvPromoHTML;
      try {
        cvPromoFoundChild = o.querySelector('img');
      }
      catch (err) {
        // continue anyway
      }
      if (typeof cvPromoFoundChild != "undefined" && cvPromoFoundChild) {
        if (typeof cvPromoFoundChild.src !== "undefined" && cvPromoFoundChild.src) {
          cvPromoImageSRC = parseUri(cvPromoFoundChild.src).host + parseUri(cvPromoFoundChild.src).path;
        }
      } else {
        cvPromoHTML = decodeURIComponent(that.text.trim());
      }
      const cvPromoCreative = (cvPromoImageSRC ? cvPromoImageSRC : cvPromoHTML) || '(not set)';
      let cvPromoKName = parseUri(that.href).queryKey['k'] || '(not set)';
      const cvPromoPromoName = parseUri(that.href).queryKey['promo'] || '(not set)';
      let cvPromoiPromoName = parseUri(that.href).queryKey['ipromo'] || '(not set)';
      if (cvPromoKName == '(not set)' && cvPromoPromoName == '(not set)' && cvPromoiPromoName == '(not set)') {
        cvPromoKName = that.href || '(not set)';
        if (cvPromoKName !== '(not set)') {
          cvPromoKName = UpdateQueryString('webSyncID', null, cvPromoKName);
          cvPromoKName = UpdateQueryString('sessionGUID', null, cvPromoKName);
        }
        cvPromoiPromoName = cvPromoCreative;
      }
      const cvPromoClickType = that.matches('div') ? 'promotionDivClick' : 'promotionClick';
      let tmpPromoLPOSs = that.getAttribute('lpos');
      if (typeof that.dataset.carousel !== "undefined" && that.dataset.carousel) {
        const tmpcars = that.dataset.carousel;
        tmpPromoLPOSs = tmpPromoLPOSs ? `${tmpcars}|${tmpPromoLPOSs}` : tmpcars;
      }
      if (cvLnkTrack.DestLPOS.includes(tmpPromoLPOSs)) {
        cvLnkTrack.DestLPOS = `${tmpPromoLPOSs}|${cvLnkTrack.DestLPOS}`;
      }
      if (cvLnkTrack.DestLPOSCD19.includes(tmpPromoLPOSs)) {
        cvLnkTrack.DestLPOSCD19 = `${tmpPromoLPOSs}|${cvLnkTrack.DestLPOSCD19}`;
      }
      window.dataLayer.push({
        event: cvPromoClickType,
        promoLPOS: tmpPromoLPOSs || '(not set)',
        ecommerce: {
          promoClick: {
            promotions: [{
              id: `${cvPromoiPromoName}|${cvPromoKName}|${cvPromoCreative}`,
              name: `${cvPromoiPromoName}|${cvPromoKName}`,
              creative: cvPromoCreative,
              position: that.getAttribute('intpromo') || '(not set)'
            }]
          }
        }
      });
    }
  }
  window.dataLayer.push({
    event: 'PageClick'
  });
  // return [Destination_LID,Destination_LPOS,cvDestination_URL,cvEvents,Destination_URL_wParam,cvDestination_URL_ext,Destination_Name,Destination_Server,Destination_Domain,cvDownloadFileExt,cvNRPPR];
  // 1. need to return sAA.events
  // 2. create variable and assign sAA.events to it
  // 3. create event tags (one for each type of event) to fire if sAA.events variable contains "event#"
}

export { cfLnkClick }
